var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/checkout/notes_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/checkout/notes_24px_2",
    d: "M5 3.99915H23V15.9991H5V3.99915ZM14 6.99915C14.7956 6.99915 15.5587 7.31522 16.1213 7.87782C16.6839 8.44043 17 9.2035 17 9.99915C17 10.7948 16.6839 11.5579 16.1213 12.1205C15.5587 12.6831 14.7956 12.9991 14 12.9991C13.2044 12.9991 12.4413 12.6831 11.8787 12.1205C11.3161 11.5579 11 10.7948 11 9.99915C11 9.2035 11.3161 8.44043 11.8787 7.87782C12.4413 7.31522 13.2044 6.99915 14 6.99915ZM9 5.99915C9 6.52958 8.78929 7.03829 8.41421 7.41336C8.03914 7.78843 7.53043 7.99915 7 7.99915V11.9991C7.53043 11.9991 8.03914 12.2099 8.41421 12.5849C8.78929 12.96 9 13.4687 9 13.9991H19C19 13.4687 19.2107 12.96 19.5858 12.5849C19.9609 12.2099 20.4696 11.9991 21 11.9991V7.99915C20.4696 7.99915 19.9609 7.78843 19.5858 7.41336C19.2107 7.03829 19 6.52958 19 5.99915H9ZM1 7.99915H3V17.9991H19V19.9991H1V7.99915Z",
    fill: "#5D6B72"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 22,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/checkout/notes_24px_3",
    d: "M5 3.99915H23V15.9991H5V3.99915ZM14 6.99915C14.7956 6.99915 15.5587 7.31522 16.1213 7.87782C16.6839 8.44043 17 9.2035 17 9.99915C17 10.7948 16.6839 11.5579 16.1213 12.1205C15.5587 12.6831 14.7956 12.9991 14 12.9991C13.2044 12.9991 12.4413 12.6831 11.8787 12.1205C11.3161 11.5579 11 10.7948 11 9.99915C11 9.2035 11.3161 8.44043 11.8787 7.87782C12.4413 7.31522 13.2044 6.99915 14 6.99915ZM9 5.99915C9 6.52958 8.78929 7.03829 8.41421 7.41336C8.03914 7.78843 7.53043 7.99915 7 7.99915V11.9991C7.53043 11.9991 8.03914 12.2099 8.41421 12.5849C8.78929 12.96 9 13.4687 9 13.9991H19C19 13.4687 19.2107 12.96 19.5858 12.5849C19.9609 12.2099 20.4696 11.9991 21 11.9991V7.99915C20.4696 7.99915 19.9609 7.78843 19.5858 7.41336C19.2107 7.03829 19 6.52958 19 5.99915H9ZM1 7.99915H3V17.9991H19V19.9991H1V7.99915Z",
    fill: "#5D6B72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.65ea4a01.svg";
export { ForwardRef as ReactComponent };